import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import './TaskGroupTraining.scss';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import {taskGroupStats} from "../../../shared/services/utils/tasks";

class TaskGroupTraining extends Component {

  constructor(props) {
    super(props);
    this.state = {
      subGroupsOpened: false
    }
  }

  get hasTaskGroups() {
    return this.props.taskGroup.subGroups && !!this.props.taskGroup.subGroups.length
  }

  render() {
    const {taskGroup} = this.props;
    const stats = taskGroupStats(taskGroup);

    return (
      <div className="task-group" key={taskGroup.guid}>
        <div className="task-group-main">
          <div className="task-group-content">
            <div className="task-group-name" style={{
              whiteSpace: "pre-line",
              unicodeBidi: "embed",
              cursor: this.hasTaskGroups? 'pointer': 'normal'
            }} onClick={() => this.setState({subGroupsOpened: !this.state.subGroupsOpened})}>
              {this.hasTaskGroups && (this.state.subGroupsOpened? <i className="fa fa-chevron-up"></i>: <i className="fa fa-chevron-down"></i>)}
              {taskGroup.name}
            </div>
            {((taskGroup.tasks && !!taskGroup.tasks.length) || (taskGroup.subGroups && !!taskGroup.subGroups.length)) && <div className="task-group-stats">
              {!stats.completedAll
                ? (
                  <Fragment>
                    <div className="stat">
                      <b>Completed </b>
                      <span
                        className={classNames('badge', stats.completed === 100 ? 'badge-success' : 'badge-secondary')}>
                      {stats.completedTasks} of {stats.totalTasks}
                    </span>
                    </div>

                    {stats.waitingAck ? (
                      <div className="stat">
                        <b>Waiting acknowledgement</b> <span className="badge badge-danger">{stats.waitingAck}</span>
                      </div>
                    ) : null}

                    {stats.substandard ? (
                      <div className="stat stat-warning">
                        <b>Performed below standard </b>
                        <span className="badge badge-danger">{stats.substandard}</span>
                      </div>
                    ) : null}

                    {stats.rejected ? (
                      <div className="stat stat-warning">
                        <b>Rejected </b>
                        <span className="badge badge-danger">{stats.rejected}</span>
                      </div>
                    ) : null}
                  </Fragment>
                )
                : (
                  <div className="stat">
                    <span className="badge badge-success">Completed</span>
                  </div>
                )}

            </div>}
          </div>
          {taskGroup.tags && taskGroup.tags.length ?
            <div className="task-group-phase">
              {taskGroup.tags.map(tag => (
                <span className="badge badge-primary" key={tag.tagGuid}>{tag.name}</span>
              ))}
            </div> : null
          }
          <div className="actions">
            <ReactTooltip
              place="top"
              className="customTheme"
              effect="solid"
            />
            {((taskGroup.tasks && !!taskGroup.tasks.length) || (taskGroup.subGroups && taskGroup.subGroups.length)) && <button data-tip="Manage tasks" className="button default small"
                     onClick={() => this.props.onOpenTasks(taskGroup)}>
              <i className="fa fa-tasks"/>
              <span>Tasks</span>
            </button>}
          </div>
        </div>

        {taskGroup.subGroups && this.state.subGroupsOpened && (
          <div className="subcategories">
            {(taskGroup.subGroups).map(sg => (
              <TaskGroupTraining
                onOpenTasks={() => this.props.onOpenTasks(sg)}
                taskGroup={sg}
                key={sg.taskGroupGuid}
              />
            ))}
          </div>
        )}

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // taskGroupMap: state.taskGroups.taskGroupMap2,
  };
}

export default connect(
  mapStateToProps,
)(TaskGroupTraining);
